<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/']">
              <i class="fas fa-home"></i>
              Página Inicial</a>
          </li>
          <li class="breadcrumb-item">
            <a [routerLink]="['/questao']">Matriz Planejamento</a>
          </li>
          <li class="breadcrumb-item active">{{ titulo }}</li>
        </ol>
      </div>
    </div>
  </div>
</div>

<div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-outline card-lightblue">
          <div class="card-header">
            <h3 class="card-title mb-0">
              <i *ngIf="this.id" class="fas fa-pencil-alt pr-2"></i>
              <i *ngIf="!this.id" class="far fa-file pr-2"></i>
              {{ titulo }}
            </h3>
          </div>

          <form [formGroup]="form" #f="ngForm">
            <div class="card-body">
              <div class="row">

                <div class="form-group col-md-12">
                  <label for="nome" class="mb-1">Matriz de Planejamento</label>
                  <input type="text" id="nome" [readonly]="visualizar" class="form-control form-control-sm"
                    formControlName="nome" maxlength="100"
                    [ngClass]="{ 'is-invalid': f.submitted && form.controls['nome'].invalid }" />
                  <div *ngIf="f.submitted && form.controls['nome'].invalid" class="invalid-feedback">
                    <div *ngIf="form.controls['nome'].errors.required">Campo obrigatório</div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="form-group col-md-12">
                  <label for="descricao" class="mb-1">Descrição</label>
                  <angular-editor [config]="config" id="descricao" rows="20" formControlName="descricao" [ngClass]="{
                      'is-invalid':
                        f.submitted && form.controls['descricao'].invalid
                    }"></angular-editor>

                  <div *ngIf="f.submitted && form.controls['descricao'].invalid" class="invalid-feedback">
                    <div *ngIf="form.controls['descricao'].errors.required">
                      Campo obrigatório
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12">
                  <div *ngIf="!visualizar" class="row">

                    <div class="form-group col-md-12">
                      <label for="inputQuestao" class="mb-1">Questão</label>
                      <div class="input-group input-group-sm" style="width: 100%;">
                        <input type="text" id="inputQuestao" class="form-control form-control-sm" readonly
                          [ngModel]="modelMatrizPlanejamentoQuestao.questao?.nome" [ngModelOptions]="{standalone: true}" />
                        <div class=" input-group-append">
                          <button type="button" class="btn btn-info" (click)="exibirModalQuestao()">
                            <i class="fas fa-search"></i>
                          </button>
                          <button type="button" class="btn btn-success" (click)="incluirQuestao()"
                              [disabled]="!(modelMatrizPlanejamentoQuestao.questaoId)">
                            <i class="fas fa-plus"></i>
                          </button>
                          <button type="button" class="btn btn-success ml-1" (click)="cadastroRapidoQuestao()">
                            <i class="fas fa-plus"></i> Adicionar
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mat-elevation-z1">
                        <table mat-table [dataSource]="questaoDataSource">
                          <tr mat-header-row *matHeaderRowDef="['nome','legislacaoAplicavelCriterio', 'actions']" class="bg-light"></tr>

                          <ng-container matColumnDef="nome">
                            <th mat-header-cell *matHeaderCellDef>Questão </th>
                            <td mat-cell *matCellDef="let element"> {{ element.questao.nome }}</td>
                          </ng-container>

                          <ng-container matColumnDef="legislacaoAplicavelCriterio">
                            <th mat-header-cell *matHeaderCellDef>Legislação Aplicável/Critério </th>
                            <td mat-cell *matCellDef="let element">
                              <a class="e2e-inner-html-bound" [innerHTML]="element.questao.legislacaoAplicavelCriterio"></a></td>
                          </ng-container>

                          <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element; let i = index" class="block">
                              <div class="btn-group">
                                <button type="button" class="btn btn-info btn-xs text-left"
                                (click)="visualizarQuestao(element.questao.id)">
                                <i class="far fas fa-eye"></i> </button>
                                <button *ngIf="!visualizar" type="button" class="btn btn-danger btn-xs text-left"
                                  (click)="excluirQuestao(i)">
                                  <i class="fa fa-trash"></i></button>
                              </div>
                            </td>
                          </ng-container>

                          <tr mat-row *matRowDef="let row; columns: ['nome','legislacaoAplicavelCriterio','actions'];"></tr>
                        </table>
                        <h5 [hidden]="!semDados" class="table-no-data">Nenhuma questão cadastrada</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          </div>

            <div class="card-footer">
              <div class="btn-group" *ngIf="!visualizar">
                <button class="btn btn-primary btn-sm mr" type="button" (click)="onSubmit(false)">
                  <i class="far fa-save"></i> Salvar
                </button>
                <button type="button" class="btn btn-primary btn-sm mr dropdown-toggle dropdown-icon" data-toggle="dropdown" aria-expanded="false"></button>
                <div class="dropdown-menu" role="menu">
                  <a class="dropdown-item" (click)="onSubmit(false)">Salvar</a>
                  <a class="dropdown-item" (click)="onSubmit(true)">Salvar e fechar</a>
                </div>
              </div>

              <button type="button" class="btn btn-default btn-sm" (click)="onBack()">
                <i class="fas fa-times"></i> Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
